var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,7.9c-0.4,0-0.8,0.3-0.8,0.8v1.6c0,0.6-0.5,1-1,1H8.5c-0.4,0-0.8,0.3-0.8,0.8c0,2.3,1.9,4.1,4.2,4.1s4.2-1.8,4.2-4.1 C16.1,9.7,14.2,7.9,12,7.9z M12,14.6c-1.2,0-2.2-0.8-2.6-1.9h0.8c1.4,0,2.5-1.1,2.5-2.5V9.5c1.1,0.3,1.9,1.3,1.9,2.5 C14.6,13.4,13.4,14.6,12,14.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22,11.8c0-0.1-2.4-7.2-10.1-7.3c-7.5,0-9.9,7.2-9.9,7.3c0,0.1,0,0.3,0,0.4c0,0.1,2.4,7.2,10,7.3c0,0,0.1,0,0.1,0 c7.5,0,9.9-7.2,9.9-7.3C22,12.1,22,11.9,22,11.8z M12.1,18L12.1,18c-5.9,0-8.1-4.9-8.5-6C4,10.9,6.1,6,12,6c5.9,0,8,4.9,8.5,6 C20,13.1,17.8,18,12.1,18z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.c1b7a3a3e987a6891a0100ea3ea45982.svg";
export { ForwardRef as ReactComponent };